// src/tabs/calendar/_source-colors.js — Phase 6 PR2 (ADR-092 + ADR-093)
//
// Factorisation des couleurs source résa pour CalendarPanel (TableauView ;
// MensuelView retirée PR #169d — TodayView consomme SOURCE_BG via bordure left).
// Préfixe `_` = convention internal-module du dossier calendar/.
//
// SOURCE_BG : couleur de fond (TableauView) ET couleur bordure left (TodayView).
// SOURCE_BORDER_STYLE : style bordure left (Arbitrage A pessimist v3 ex-MensuelView) :
//   - Booking 'dashed' = redondance accessibilité daltoniens (WCAG AA). Depuis le
//     passage de Direct au vert DS.green (#2d7a3a), Direct et Booking (#003580)
//     sont déjà bien séparés en teinte ; le dashed reste par sécurité.
//   - Airbnb + Direct 'solid' (pas d'ambiguïté avec #FF5A5F corail).
//
// Cf. ADR-033 (Phase 2.G.6 pattern SOURCE_BG TableauView original).
// Cf. ADR-093 (pivot UX Phase 6 PR2 — intégration prix CalendarPanel).

import { DS } from '../../lib/ui'

// DA (DESIGN.md §8 bis) — couleur de fond de la barre = SOURCE uniquement,
// franchement distincte d'une source à l'autre (lecture d'un coup d'œil) :
//   Airbnb  = corail-rouge srcAirbnb (proche couleur réelle Airbnb)
//   Booking = marine srcBooking (proche couleur réelle Booking)
//   Direct  = vert srcDirect (résa « gagnée », inclut la sous-loc interne FBZ)
// La couleur de fond n'encode QUE la source : elle ne change jamais selon l'état.
export const SOURCE_BG = {
  airbnb: DS.srcAirbnb,   // #E8632E corail-rouge
  booking: DS.srcBooking, // #215387 marine
  direct: DS.srcDirect,   // #1D9E75 vert (Direct ET sous-loc interne FBZ)
}

export const SOURCE_BORDER_STYLE = {
  airbnb: 'solid',
  booking: 'dashed',   // Arbitrage A pessimist v3 — accessibilité daltoniens
  direct: 'solid',
}

export const SOURCE_BG_FALLBACK = '#94a3b8'         // gris slate (source inconnue)
export const SOURCE_BORDER_STYLE_FALLBACK = 'solid'

// Phase 6 PR4 commit 10 — UX-1 : lisibilité prix dans cellules calendrier.
//
// Couleur #374151 (gray-700) + fontSize 10-11px + fontWeight 500 (medium).
// Hiérarchie préservée : voyageurs (barres résa) restent prioritaires.
// pointerEvents:'none' obligatoire pour laisser priorité click aux barres résa
// (cf. BPRv3-1 PR3 — z-index barres > z-index cellules).
//
// variant 'tableau' : 10px (TableauView Gantt-style, cellules étroites ~38px).
// variant 'mensuel' : 11px (ex-MensuelView, gardé pour re-usage potentiel
//   vue Liste PR #169c — F-10 PR #169d : zero runtime impact post-suppression).
export const PRICING_TEXT_STYLE = {
  tableau: { color: '#374151', fontSize: 10, fontWeight: 500, pointerEvents: 'none' },
  mensuel: { color: '#374151', fontSize: 11, fontWeight: 500, pointerEvents: 'none' },
}
